<template>
  <div :class="['section-wrapper p-4 main-text-color inter-font', className]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: {
    // You can add props here if needed in the future
    className: String,
  },
}
</script>

<style scoped>

.section-wrapper {
  border: 1px solid #cfd3d9;
  border-radius: 8px;
}
.main-text-color {
  color: #374151;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/Card.vue